/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {MainLayout} from '~/layouts/main';
export const meta = {
  title: 'DIP | Ограничения и подводные камни',
  description: 'Ограничения принципа инверсии зависимостей, с которыми разработчики сталкиваются чаще всего'
};
const MDXLayout = ({children}) => _jsx(MainLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    section: "section",
    h1: "h1",
    p: "p",
    a: "a",
    h2: "h2",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return _jsxs(_components.section, {
    children: [_jsx(_components.h1, {
      children: "Ограничения и подводные камни"
    }), _jsxs(_components.p, {
      children: ["Принцип инверсии зависимостей может приводить к ситуациям, когда поток управления программы задан неявно, а ", _jsx(_components.a, {
        href: "https://ru.wikipedia.org/wiki/%D0%94%D0%B7%D0%B5%D0%BD_%D0%9F%D0%B8%D1%82%D0%BE%D0%BD%D0%B0",
        children: "явное — лучше неявного"
      }), "."]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Неграмотное использование"
      }), _jsxs(_components.p, {
        children: ["При неграмотном и бесконтрольном использовании принципа и IoC-контейнеров в частности логика взаимодействия компонентов ", _jsx(_components.a, {
          href: "https://blog.byndyu.ru/2009/12/blog-post.html",
          children: "может оказаться размазанной"
        }), " по разным частям приложения. Это мешает восприятию программы, снижает тестируемость и увеличивает стоимость внесения изменений."]
      }), _jsxs(_components.p, {
        children: ["Кроме того, не все зависимости ", _jsx(_components.a, {
          href: "https://habr.com/ru/post/313796/",
          children: "стоят того, чтобы их инвертировать"
        }), ". Отличить такие от остальных бывает трудно из-за, например, специфики предметной области."]
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Проблемы с внедрением зависимостей"
      }), _jsxs(_components.p, {
        children: ["С инъекцией зависимостей тоже ", _jsx(_components.a, {
          href: "https://medium.com/@sawomirkowalski/design-patterns-dependency-injection-and-its-variations-16007d0fa367",
          children: "могут возникать проблемы"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["При инъекции через конструктор большое количество зависимостей сильно увеличивает конструктор. А при неграмотном использовании DI могут появиться ", _jsx(_components.a, {
          href: "https://ru.wikipedia.org/wiki/Dependency_hell",
          children: "циклические зависимости"
        }), "."]
      }), _jsxs(_components.p, {
        children: ["В обоих случаях стоит посмотреть в сторону ", _jsx(_components.a, {
          href: "/srp",
          children: "SRP"
        }), ". Скорее всего, класс делает слишком много, и его надо разбивать на более мелкие."]
      })]
    }), _jsxs(_components.section, {
      children: [_jsx(_components.h2, {
        children: "Материалы к разделу"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/%D0%94%D0%B7%D0%B5%D0%BD_%D0%9F%D0%B8%D1%82%D0%BE%D0%BD%D0%B0",
            children: "Дзен Питона"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://blog.byndyu.ru/2009/12/blog-post.html",
            children: "Принцип инверсии зависимостей"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://habr.com/ru/post/313796/",
            children: "Разбираемся с SOLID: Инверсия зависимостей"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://medium.com/@sawomirkowalski/design-patterns-dependency-injection-and-its-variations-16007d0fa367",
            children: "Dependency Injection and its variations"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://ru.wikipedia.org/wiki/Dependency_hell",
            children: "Dependency Hell"
          })
        }), "\n"]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
